import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Contains = ({ property, onChange, value }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type, 'CONTAINS_EXACT')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        description={"This field is case-sensitive."}
        isOperator={true}
      />
    </div>
  )
}

export default Contains
